var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-page-content" },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "title-wrapper" }, [
          _c("h1", { staticClass: "main-title" }, [
            _vm._v(_vm._s(_vm.$t("voiceagent.batchCall"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title-description" }, [
            _vm._v(_vm._s(_vm.$t("voiceagent.batchCallDescription"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.showCreateForm
        ? _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("voiceagent.createNewBatchCall"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "batch-call-form" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { icon: "arrow_back" },
                    on: {
                      click: function ($event) {
                        _vm.showCreateForm = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("voiceagent.backToList")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "batch-call-cost-info" },
                  [
                    _c("a-icon", { attrs: { type: "info-circle" } }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("voiceagent.batchCallCostInfo")) +
                        "\n            "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form",
                  {
                    attrs: { form: _vm.form, layout: "vertical" },
                    on: { submit: _vm.handleSubmit },
                  },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.batchCallName") } },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "name",
                                {
                                  rules: _vm.batchNameRules,
                                },
                              ],
                              expression:
                                "[\n                            'name',\n                            {\n                                rules: batchNameRules\n                            }\n                        ]",
                            },
                          ],
                          attrs: {
                            placeholder: _vm.$t("voiceagent.enterCampaignName"),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.callerNumber") } },
                      [
                        _c(
                          "a-select",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "fromNumber",
                                  {
                                    rules: _vm.batchFromNumberRules,
                                  },
                                ],
                                expression:
                                  "[\n                            'fromNumber',\n                            {\n                                rules: batchFromNumberRules\n                            }\n                        ]",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t("voiceagent.selectNumber"),
                            },
                          },
                          _vm._l(_vm.phoneNumbers, function (number) {
                            return _c(
                              "a-select-option",
                              {
                                key: number.phone_number,
                                attrs: { value: number.phone_number },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      number.nickname
                                        ? number.nickname +
                                            " (" +
                                            number.phone_number +
                                            ")"
                                        : number.phone_number
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.voiceAgent") } },
                      [
                        _c(
                          "a-select",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "agentId",
                                  {
                                    rules: _vm.batchAgentRules,
                                  },
                                ],
                                expression:
                                  "[\n                            'agentId',\n                            {\n                                rules: batchAgentRules\n                            }\n                        ]",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t(
                                "voiceagent.selectVoiceAgent"
                              ),
                              loading: _vm.loadingAgents,
                              "show-search": "",
                              "option-filter-prop": "children",
                            },
                          },
                          _vm._l(_vm.agents, function (agent) {
                            return _c(
                              "a-select-option",
                              {
                                key: agent.agent_id,
                                attrs: { value: agent.agent_id },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(agent.agent_name || agent.agent_id) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.recipients") } },
                      [
                        _c(
                          "div",
                          { staticClass: "upload-container" },
                          [
                            _c(
                              "div",
                              { staticClass: "upload-actions" },
                              [
                                _c(
                                  "a-upload",
                                  {
                                    attrs: {
                                      customRequest: _vm.handleFileUpload,
                                      showUploadList: false,
                                      beforeUpload: _vm.beforeUpload,
                                      accept: ".csv",
                                    },
                                  },
                                  [
                                    _c("SupsisButton", [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("upload")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("voiceagent.uploadCsvFile")
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { type: "link" },
                                    on: { click: _vm.downloadTemplate },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("download"),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("voiceagent.downloadTemplate")
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.csvError
                              ? _c("a-alert", {
                                  attrs: {
                                    type: "error",
                                    message: _vm.csvError,
                                    banner: "",
                                    closable: "",
                                  },
                                  on: {
                                    close: function ($event) {
                                      _vm.csvError = ""
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.csvData.length > 0
                              ? _c("div", { staticClass: "csv-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "csv-file-info" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("description")]
                                      ),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.fileName) +
                                          "\n                                "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("voiceagent.personCount", {
                                              count: _vm.csvData.length,
                                            })
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "SupsisButton",
                                        {
                                          attrs: {
                                            type: "link",
                                            size: "small",
                                          },
                                          on: { click: _vm.handleClearCsv },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("delete")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.whenToCall") } },
                      [
                        _c(
                          "a-radio-group",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "callSchedule",
                                  {
                                    initialValue: "now",
                                  },
                                ],
                                expression:
                                  "[\n                            'callSchedule',\n                            {\n                                initialValue: 'now'\n                            }\n                        ]",
                              },
                            ],
                            on: { change: _vm.handleScheduleChange },
                          },
                          [
                            _c("a-radio", { attrs: { value: "now" } }, [
                              _vm._v(_vm._s(_vm.$t("voiceagent.callNow"))),
                            ]),
                            _vm._v(" "),
                            _c("a-radio", { attrs: { value: "schedule" } }, [
                              _vm._v(_vm._s(_vm.$t("voiceagent.schedule"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isScheduled
                      ? _c(
                          "div",
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: { label: _vm.$t("voiceagent.callTime") },
                              },
                              [
                                _c("a-date-picker", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "scheduleDate",
                                        {
                                          rules: _vm.batchScheduleDateRules,
                                        },
                                      ],
                                      expression:
                                        "[\n                                'scheduleDate',\n                                {\n                                    rules: batchScheduleDateRules\n                                }\n                            ]",
                                    },
                                  ],
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    showTime: { format: "HH:mm" },
                                    format: "YYYY-MM-DD HH:mm",
                                    placeholder: _vm.$t(
                                      "voiceagent.selectDateTime"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-form-item",
                              {
                                attrs: { label: _vm.$t("voiceagent.timezone") },
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: [
                                          "timezone",
                                          {
                                            initialValue: "Europe/Istanbul",
                                            rules: _vm.batchTimezoneRules,
                                          },
                                        ],
                                        expression:
                                          "[\n                                'timezone',\n                                {\n                                    initialValue: 'Europe/Istanbul',\n                                    rules: batchTimezoneRules\n                                }\n                            ]",
                                      },
                                    ],
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "voiceagent.selectTimezone"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "Europe/Istanbul" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "voiceagent.timezoneEuropeIstanbul"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "Europe/London" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "voiceagent.timezoneEuropeLondon"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "America/New_York" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "voiceagent.timezoneAmericaNewYork"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "Asia/Tokyo" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "voiceagent.timezoneAsiaTokyo"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("a-form-item", [
                      _c(
                        "div",
                        { staticClass: "form-actions" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.submitting,
                                disabled: !_vm.canSubmit,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("voiceagent.startBatchCall")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showCreateForm = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("voiceagent.cancel")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "section" }, [
            _c(
              "div",
              { staticClass: "table-wrapper" },
              [
                _c("div", { staticClass: "toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c("a-input-search", {
                        staticClass: "search-input",
                        staticStyle: {
                          width: "300px",
                          margin: "unset !important",
                        },
                        attrs: { placeholder: _vm.$t("voiceagent.search") },
                        on: { input: _vm.onSearch },
                        model: {
                          value: _vm.searchText,
                          callback: function ($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.create"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: { primary: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showCreateForm = true
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("voiceagent.newBatchCall")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-spin",
                  { attrs: { spinning: _vm.loading } },
                  [
                    _c("SupsisTable", {
                      attrs: {
                        columns: _vm.tableColumns,
                        rows: _vm.paginatedBatchCalls,
                        "top-pagination": true,
                        "empty-data-bordered": "",
                        "bottom-pagination": false,
                        "pagination-cursor": _vm.pagination,
                        options: {
                          rowStyleOption: _vm.rowStyleOption,
                          clipboardOption: _vm.clipboardOption,
                          fixedHeader: true,
                          id: "batch-calls-table",
                          borderX: true,
                          borderY: true,
                        },
                      },
                      on: {
                        "cursor-changed": function (cursor) {
                          return (_vm.pagination = cursor)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
      _vm._v(" "),
      _c(
        "a-drawer",
        {
          attrs: {
            title: _vm.$t("voiceagent.recipients"),
            placement: "right",
            visible: _vm.showRecipients,
            width: 600,
          },
          on: {
            close: function ($event) {
              _vm.showRecipients = false
            },
          },
        },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.recipientColumns,
              dataSource: _vm.csvData,
              pagination: { pageSize: 10 },
            },
            scopedSlots: _vm._u([
              {
                key: "index",
                fn: function (text, record, index) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(index + 1) +
                        "\n            "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }